import { Capability } from '@olxpwa-lib/utils/constants';
import { isBrowser } from '@olxpwa-lib/utils/fn';
import newRelic from './newRelic';

declare global {
    // eslint-disable-next-line no-var
    var nr: typeof import('newrelic') | void;
}

export const captureExceptionNewRelic: typeof newRelic.noticeError = (
    exception,
    customAttrs
) => {
    const attributes = {
        team: 'eu-services-seeker',
        ...customAttrs,
        category: 'thrown_by_fm',
        capability: Capability.JobsAndServicesOLXServices
    };
    if (isBrowser()) {
        newRelic.noticeError(exception, attributes);
        return;
    }
    const nodeNr = global?.nr;
    nodeNr?.noticeError(exception as Error, attributes);
};
